import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IngredientCreateSelectProviderPage } from '../../ingredient-create/ingredient-create-select-provider/ingredient-create-select-provider';

/**
 * Generated class for the IngredientViewProvidersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-providers',
    templateUrl: 'ingredient-view-providers.html',
})
export class IngredientViewProvidersPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    editProviders() {
        this.navCtrl.push(IngredientCreateSelectProviderPage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            ingredients: this.ingredient,
            ingredient_name: this.ingredient.name,
            ingredient_measurement: this.ingredient.measurement
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-providers/ingredient-view-providers.ts